// Copyright (c) 2019 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";

import MonitorGraph from "view/comp/MonitorGraph";
import MonitorSiteBar from "view/comp/MonitorSiteBar";

class MonitorComponent extends React.Component {
  public render() {
    return (
      <>
        <MonitorSiteBar showPeriodSelect={false} />
        <div id="monitor" className="flex-self flex-content graph-shrink">
          <MonitorGraph />
        </div>
      </>
    );
  }
}

export default MonitorComponent;
